import { forwardRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import { config } from '@percent/cause-dashboard/config'

declare global {
  interface Window {
    recaptchaOptions?: { enterprise?: boolean; useRecaptchaNet?: boolean }
  }
}

/*
  The one place the Causes Portal sets its reCAPTCHA Enterprise sitekey and script.

  react-google-recaptcha reads window.recaptchaOptions when the widget mounts to choose api.js or
  enterprise.js, so the option is set before it mounts.

  The script loads from recaptcha.net rather than www.google.com, so consent tools and CSPs can allow
  reCAPTCHA by host without allowing the rest of www.google.com.
*/
export const CaptchaWidget = forwardRef<ReCAPTCHA>((_props, ref) => {
  window.recaptchaOptions = {
    ...window.recaptchaOptions,
    useRecaptchaNet: true,
    enterprise: true
  }

  return <ReCAPTCHA ref={ref} size="invisible" sitekey={config.keys.googleCaptchaEnterprise} />
})

CaptchaWidget.displayName = 'CaptchaWidget'
